'use strict';

const angular = require('angular');

/**
 * Removes server error when user updates input
 */
export default angular.module('directives.mongooseError', [])
  .directive('mongooseError', function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, element, attrs, ngModel) {
        element.on('keydown', () => ngModel.$setValidity('mongoose', true));
      }
    };
  }).name;



// WEBPACK FOOTER //
// ./client/components/mongoose-error/mongoose-error.directive.js